import {TicketSetBuyResultVo} from '../../common/shared/api/nicolas/vo/TicketSetBuyResultVo.interface';
import {TicketSetBuyMutationPayload} from '../generated/types';

export function createTicketSetBuyMutationPayload({
  remain_cash,
}: TicketSetBuyResultVo): TicketSetBuyMutationPayload {
  return {
    remainCash: remain_cash,
  };
}
